<template>
	<div class="list-item">
		<template v-if="bullet === 'check_icon'">
			<svg
				class="list-item-bullet"
				width="11"
				height="10"
				viewBox="0 0 11 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10 1.5L5.57478 8.49294C5.24231 9.01832 4.51608 9.11617 4.05641 8.69752L1 5.91379"
					stroke="#7D8BF7"
					stroke-width="2"
					stroke-linecap="round"
				/>
			</svg>
		</template>
		<div class="list-item-content">
			<slot></slot>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	font-size: 16px;
	line-height: 19px;
	font-weight: 400;
	color: #323653;

	&-bullet {
		display: block;
		margin-right: 10px;
		margin-bottom: 0;
		min-width: 16px;
	}
}
</style>

<script>
export default {
	name: 'ListItem',
	props: {
		bullet: {
			type: String,
			default: 'check_icon',
			validator: (value) => {
				return ['check_icon', 'bullet'].includes(value)
			}
		}
	}
}
</script>
